import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface CMSContentRow {
  id: string;
  key: string;
  title: string;
  status: string;
  language: string;
  meta_title?: string | null;
  meta_description?: string | null;
  featured_image?: string | null;
  content: any;
}

export const useCMSContent = (key: string, language: string = 'fr') => {
  const [content, setContent] = useState<CMSContentRow | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchContent = async () => {
      try {
        setLoading(true);
        // Ajouter un timestamp pour forcer le bypass du cache navigateur
        const cacheBuster = `?_=${Date.now()}`;
        const { data, error } = await supabase
          .from('cms_content')
          .select('*')
          .eq('key', key)
          .eq('status', 'published')
          .eq('language', language)
          .limit(1)
          .maybeSingle();

        if (error) throw error;

        if (!isMounted) return;

        if (data) {
          let parsedContent: any = {};
          try {
            parsedContent = typeof data.content === 'string' ? JSON.parse(data.content) : data.content;
          } catch {
            parsedContent = data.content;
          }
          setContent({ ...(data as any), content: parsedContent });
        } else {
          setContent(null);
        }
      } catch (e: any) {
        if (!isMounted) return;
        setError(e.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchContent();

    return () => { isMounted = false; };
  }, [key, language]);

  return { content, loading, error };
};
